export const ON_LOAD_CONFIG = "ON_LOAD_CONFIG";
export const CABINET_TYPE_ADVERT = "ADVERT";
export const CABINET_TYPE_DSP = "DSP";
export const CABINET_TYPE_EXCHANGE = "EXCHANGE";
export const CABINET_TYPE_WEBMASTER = "WEBMASTER";
